import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { EmploymentFormValues } from '../../../../store/types/form/EmploymentFormValues'
import NumericInput from '../../Inputs/NumericInput'

type Props = {
  index: number
}

const VacationPeriodOvertimeInput = ({ index }: Props) => {
  const { t } = useTranslation()
  const { control } = useFormContext<EmploymentFormValues>()

  return (
    <NumericInput
      control={control}
      name={`vacationPeriods.${index}.overtime`}
      label={t('page.employments.table.overtime')}
      numericType="natural"
    />
  )
}

export default VacationPeriodOvertimeInput
